/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import { LocationType } from '../../model/LocationType';
import { LocationTypesService } from '../../services/location-types.service';
import { LocationsService } from '../../services/locations.service';
import { Location } from '../../model/Location';
import { Site } from '../../model/Site';
import { SitesService } from '../../services/sites.service';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-locations',
    templateUrl: './locations.component.html',
    standalone: false
})
export class LocationsComponent extends BaseMessageComponent implements OnInit {
    public sites: Site[];
    public locations: Location[];
    public locationTypes: LocationType[];
    public indexWithChanges: number[] = [];

    constructor(
        private siteService: SitesService,
        private locationTypeService: LocationTypesService,
        private locationService: LocationsService,
        private spinnerService: NgxSpinnerService,
        cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        this.getSites();
        this.getLocationTypes();
        this.getLocations();
    }

    public addNew(locationName, siteId, locationTypeId): void {
      if (locationName.trim() == "") {
        alert("Please add a name before saving a new record.");
      } else {
        this.spinnerService.show();

        var location = new Location();
        location.locationName = locationName;
        location.siteId = siteId;
        location.locationTypeId = locationTypeId;
        location.active = true;

        this.locationService.addNew(location).subscribe(value => {
            this.locations = null;
            this.getLocations();
          },
          (error) => {
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
            this.spinnerService.hide();
          },
          () => {
            this.spinnerService.hide();
          });
      }
    }

    public saveChanges(): void {
        this.spinnerService.show();

        if (this.indexWithChanges.length > 0) {
            for (var i = 0; i < this.indexWithChanges.length; i++) {
                var idx = this.indexWithChanges[i];
                this.locationService.updateLocations(this.locations[idx]).subscribe(value => {
                    console.log(this.locations[idx] + " saved.")
                },
                (error) => {
                    this.spinnerService.hide();
                    console.error(error);
                  if (error.status=='409')
                    alert("Duplicate Value(s) found.");
                  else
                    alert(error.message);
                },
                () => {
                    this.spinnerService.hide();
                    this.indexWithChanges = [];
                });
            }
            setTimeout(() => {
                this.getLocations();
            }, 3000);
        } else {
          this.spinnerService.hide();
          alert("No changes to save.");
        }
    }

    public updateIndexes(index): void {
        if (this.indexWithChanges.indexOf(index) === -1) {
            this.indexWithChanges.push(index);
        }
        console.log(this.indexWithChanges);
    }

    private getSites(): void {
        this.siteService.getAllSites().subscribe(
            sites => {
                this.sites = sites;
                this.cdr.detectChanges();
            }
        );
    }

    private getLocationTypes(): void {
        this.locationTypeService.getAll().subscribe(
            locationTypes => {
                this.locationTypes = locationTypes;
                this.cdr.detectChanges();
            }
        )
    }

    private getLocations(): void {
        this.locationService.getAll().subscribe(
            locations => {
                this.locations = locations;
                this.cdr.detectChanges();
            }
        )
    }
}
